import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-messages-icon',
  templateUrl: './messages-icon.component.html',
  styleUrls: ['./messages-icon.component.scss']
})
export class MessagesIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
